import React, { useEffect, useState } from "react";

import { Environment, setupEnvironment } from "./environment/environment";
import { Router } from "./router/Router";
import { UserContextProvider } from "./context/UserContext";

function App() {
  const [environment, setEnvironment] = useState<Environment | undefined>(
    undefined
  );

  useEffect(() => {
    (async () => {
      try {
        await setupEnvironment().then((env) => setEnvironment(env));
      } catch (err) {
        console.error(`Error setup ${err}`);
      }
    })();
  }, []);

  if (!environment) {
    return null;
  } else {
    return (
      <UserContextProvider>
        <Router />
      </UserContextProvider>
    );
  }
}

export default App;
